import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type DeleteWorkRequest = {
  workRequestId: string;
};

export type DeleteWorkRequestParams = RequestConfig<DeleteWorkRequest>;

export const deleteWorkRequest = async ({
  params,
  config
}: DeleteWorkRequestParams) =>
  api.delete(`/api/work/requests/${params.workRequestId}`, config);
